webpackJsonpUpdateBris([85],{

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SelectBox = exports.SelectBox = function () {
	function SelectBox($el) {
		_classCallCheck(this, SelectBox);

		// $el is the blk node return by the loadSelectBox function
		this.$el = $el;
		this._onChange = function () {};
	}

	_createClass(SelectBox, [{
		key: 'init',
		value: function init() {
			this.initSelectbox(this.$el);
			return this;
		}
	}, {
		key: 'initSelectbox',
		value: function initSelectbox($el) {
			var This = this;
			$($el).find('.dropdown-item:not(.disabled)').click(function () {
				var $parent = $(this).closest('.selectbox');
				var $title = $parent.find('.selectbox-title');

				$title.text(this.dataset.name || '');

				$parent.attr('data-name', this.dataset.name || '');
				$parent.attr('data-value', this.dataset.value || '');
				$parent.trigger('change', [this.dataset, this]);
				This._onChange(this.dataset, this);
			});
		}
	}, {
		key: 'onChange',
		value: function onChange(callBack) {
			this._onChange = callBack;
			return this;
		}
	}]);

	return SelectBox;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ })

});


// WEBPACK FOOTER //
// 1754042353042.blk-select-box-chunk.js